import React from "react";
import { Navigate } from "react-router";
import Base from "./Base";

export default class AggregateEvent extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            type: props.Type,
            caller: props.Caller,
            data: null,
            loading: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var url = "";
        if (this.state.type === 1) url = "api/v1/aggregateevent/get/meeting"

        this.httpPost(url, {
            id: this.state.id,
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false,
                });
            }
            else {
                this.showErorrMessage(data.message);
            }
        });
    }
    getCaption() {
        if (this.state.type === 1) return "جلسه";
        return "";
    }
    getMeetingBody() {
        return <div className="modal-body" >
            <div className="container-fluid">
                <div className="row">
                    {!this.isBlank(this.state.data.record.subject) && <div className="col-lg-12">
                        <b>موضوع جلسه:</b> {this.state.data.record.subject}
                    </div>}
                    {!this.isBlank(this.state.data.record.meetingStatusString) && <div className="col-lg-3">
                        <b>وضعیت جلسه:</b> {this.state.data.record.meetingStatusString}
                    </div>}
                    {!this.isBlank(this.state.data.record.dateString) && <div className="col-lg-3">
                        <b>تاریخ جلسه:</b> {this.state.data.record.dateString}
                    </div>}
                    {!this.isBlank(this.state.data.record.time) && <div className="col-lg-3">
                        <b>ساعت جلسه:</b> {this.state.data.record.time}
                    </div>}
                    {!this.isBlank(this.state.data.record.typeString) && <div className="col-lg-3">
                        <b>نحوه برگزاری جلسه:</b> {this.state.data.record.typeString}
                    </div>}
                    {!this.isBlank(this.state.data.record.address) && <div className="col-lg-12">
                        <b>محل برگزاری جلسه:</b> {this.state.data.record.address}
                    </div>}
                    {!this.isBlank(this.state.data.record.agendaText) && <div className="col-lg-12">
                        <b>دستور جلسه:</b> {this.state.data.record.agendaText}
                    </div>}
                    {!this.isBlank(this.state.data.record.meetingResultString) && <div className="col-lg-12">
                        <b>نتیجه جلسه:</b> {this.state.data.record.meetingResultString}
                    </div>}
                    {!this.isBlank(this.state.data.record.resultText) && <div className="col-lg-12">
                        <b>تصمیمات جلسه:</b>
                        <div dangerouslySetInnerHTML={{ __html: this.convertNewLines(this.state.data.record.resultText) }}></div>
                    </div>}
                </div>
            </div>
        </div>
    }
    renderForm() {
        return (
            <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
                <div className="modal-backdrop fade in" style={{ height: "100%" }} onClick={(e) => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable" style={{ minWidth: "90%" }}>
                    <div className="modal-content">
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={(e) => this.closeMe()} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title">محتوای {this.getCaption()}</h4>
                        </div>
                        {this.state.type === 1 && this.getMeetingBody()}
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={(e) => this.closeMe()}>بازگشت</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}